import { Icon } from '@shopify/polaris';
import { CancelMajor } from '@shopify/polaris-icons';
import { useEffect, useState } from 'react';

const DesignLayout = {
  default: 'w-2/3 mx-auto my-14',
  inline: '',
};

const DesignInput = {
  default: 'w-full border-b border-gray-300 text-center p-2',
  inline: 'w-full border border-gray-400 rounded p-2',
};

const ProductFindCard = ({
  onSearch,
  onClearSearch,
  product,
  optionList,
  children,
  autoclean,
  design = DesignLayout.default,
  inputDesign = DesignInput.default,
}) => {
  const [searchValue, setSearchValue] = useState('');
  const [timer, setTimer] = useState(null);

  const handleClearSearch = () => {
    setSearchValue('');
    onClearSearch();
  };

  const handleSearch = ({ target }) => {
    const { value } = target;

    if (value === '') {
      handleClearSearch();
      return;
    }

    setSearchValue(value);
    clearTimeout(timer);

    const newTimer = setTimeout(() => {
      if (searchValue !== '') onSearch(value);
    }, 500);

    setTimer(newTimer);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  useEffect(() => {
    if (product) {
      setSearchValue('');
    }
  }, [product]);

  useEffect(() => {
    autoclean && setSearchValue('');
  }, [autoclean]);

  return (
    <>
      {product ? (
        children
      ) : (
        <div className={DesignLayout[design] ?? design}>
          <div className="flex items-center justify-center ">
            <input
              value={searchValue}
              onChange={handleSearch}
              type="text"
              placeholder="Buscar por título, SKU o por EAN"
              className={DesignInput[inputDesign] ?? inputDesign}
              list="options"
              autoFocus={true}
            />

            <datalist id="options">
              {optionList.map((option) => (
                <option key={option} value={option} />
              ))}
            </datalist>

            <button
              onClick={handleClearSearch}
              className="text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center"
              disabled={!searchValue}
            >
              <Icon source={CancelMajor} />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ProductFindCard;
